
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import goldf from '../images/Discussion_Forum_Wordmark.png';
import { GROUP_STATE_ACTIVE } from '../../../../../store/actions/gameActions';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button'; 
import { hasGameControl, getUserGroup } from '../../game_functions/functions'
import { updateGroupState } from './../../../../../store/actions/gameActions';
import Typography from '@material-ui/core/Typography';
import styles from '../../../../Styles';

class Instructions extends Component {

    componentDidMount() {
        window.scrollTo(0, 0)
    }

    sendToNextStep = (event) => {
        if ( this.props.profile.role === 'host' ){
            let groupID = this.props.session.hostState.params.group ? this.props.session.hostState.params.group : null;
            let s = { 
                    'state' : GROUP_STATE_ACTIVE,
                    'params' : {}
            };
            this.props.updateGroupState(groupID, s, this.props.auth.uid);   
        } else {
            let groupID = getUserGroup(this.props.session, this.props.auth.uid);
            let s = { 
                    'state' : GROUP_STATE_ACTIVE,
                    'params' : {}
            };
            this.props.updateGroupState(groupID, s, this.props.profile.sessionHost);
        }
    }

    render(){
        const { profile, auth, classes, leader } = this.props;
        return (
            <div>
               
               <Grid container spacing={3}>
                    <Grid item xs={12} sm={6}>
                        <img src={goldf} className={classes.imageStyle} alt="Game"/>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <blockquote><span className="blocktext">A good discussion increases the dimensions of everyone who takes part.</span> <br/><br/><span className={classes.boldedText}>– Randolph Bourne</span>
                        </blockquote>
                        <Typography variant="h6" className={classes.spacingBottom}>Discuss the Upcoming Leadership Program</Typography>
                        <Typography variant='body1' className={classes.spaceBottom}>Leadership is a journey, not a destination. As your teams embark on this
journey, consider these things:
                        </Typography>
                        <ol className="browser-default" style={{fontSize:"1.2rem"}}>
                            <li>What will success look and sound like when your leaders have successfully completed this learning program?</li>
                            <li>What potential obstacles will get in the way of success and how will you overcome these things?</li>
                        </ol>
                        <br/><br/>
                        { hasGameControl(leader, auth.uid, profile)
                            ?
                            <Button type='submit' color="primary" variant='contained' onClick={this.sendToNextStep}>
                                Continue
                            </Button>
                            :
                            <Button type='submit' disabled={true} variant='contained'>
                                Leader can hit Continue
                            </Button>
                        }
                    </Grid>
                </Grid> 
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return { };
  };
  
  const mapDispatchToProps = (dispatch) => {
    return {
        updateGroupState : (group, groupState, hostID) => dispatch(updateGroupState(group, groupState, hostID))
    };
  };
  
  export default compose(
    connect(mapStateToProps, mapDispatchToProps),
    withStyles(styles)
  )(Instructions);
